import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { MemoryRouter, Router, Route, Routes } from 'react-router-dom';
import About from './pages/About';
import Awards from './pages/Awards';
import Publications from './pages/Publications';
import Education from './pages/Education';
import NavbarComponent from './comps/NavbarComponent';


function App() {
  return (

    <div className="App">
      <div className="app-bar">
          <h1>Salman Estyak</h1>
      </div>
      <MemoryRouter>
          <NavbarComponent />
          <Routes>
            <Route path="/" element={<About/>} />
            <Route path="/about" element={<About/>} />
            <Route path="/education" element={<Education/>} />
            <Route path="/publications" element={<Publications/>} />
            <Route path='/awards' element={<Awards/>}/>
          </Routes>
      </MemoryRouter>

    </div>

  );
}

export default App;
